/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { AdminGetCurrentAdminUserInfoInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetCurrentAdminUserInfoNotFoundDto } from '../../src/model';
// @ts-ignore
import type { AdminGetCurrentAdminUserInfoOkDto } from '../../src/model';
// @ts-ignore
import type { AdminGetUserByUserUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetUserByUserUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { AdminGetUserByUserUuidOkDto } from '../../src/model';
// @ts-ignore
import type { AdminGetUsersInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetUsersNameInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetUsersNameOkDto } from '../../src/model';
// @ts-ignore
import type { AdminGetUsersOkDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchHandlingWithdrawalComplainInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchHandlingWithdrawalComplainOkDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchHandlingWithdrawalComplainReqBodyDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchUserByUserUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchUserByUserUuidNotFoundDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchUserByUserUuidOkDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchUserByUserUuidReqBodyDto } from '../../src/model';
// @ts-ignore
import type { AdminPatchUserPointByUserUuidsReqBodyDto } from '../../src/model';
// @ts-ignore
import type { CreateInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { CreateWithTargetUuidInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetRegisterPathInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetRegisterPathListInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetRegisterPathListOkDto } from '../../src/model';
// @ts-ignore
import type { GetRegisterPathOkDto } from '../../src/model';
// @ts-ignore
import type { JwtAdminAccessGuardUnauthorizedDto } from '../../src/model';
/**
 * AdminUsersApi - axios parameter creator
 * @export
 */
export const AdminUsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 전체 관리자 회원명 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerAdminGetAdminUsersName: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/users/name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 관리자 본인 정보 가져오기
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerAdminGetCurrentAdminUserInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 관리자 회원 상세 조회
         * @param {string} userUuid 유저 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerAdminGetUserByUserUuid: async (userUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userUuid' is not null or undefined
            assertParamExists('adminUsersControllerAdminGetUserByUserUuid', 'userUuid', userUuid)
            const localVarPath = `/admin/users/{userUuid}`
                .replace(`{${"userUuid"}}`, encodeURIComponent(String(userUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 관리자 회원 목록 조회
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {AdminUsersControllerAdminGetUsersCategoryEnum} [category] 유저 카테고리
         * @param {AdminUsersControllerAdminGetUsersLevelEnum} [level] 등급
         * @param {AdminUsersControllerAdminGetUsersSortEnum} [sort] 정렬 기준
         * @param {AdminUsersControllerAdminGetUsersSortOrderEnum} [sortOrder] 정렬 순서
         * @param {AdminUsersControllerAdminGetUsersSearchTypeEnum} [searchType] 검색 타입
         * @param {string} [keyword] 검색어
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerAdminGetUsers: async (page?: number, limit?: number, category?: AdminUsersControllerAdminGetUsersCategoryEnum, level?: AdminUsersControllerAdminGetUsersLevelEnum, sort?: AdminUsersControllerAdminGetUsersSortEnum, sortOrder?: AdminUsersControllerAdminGetUsersSortOrderEnum, searchType?: AdminUsersControllerAdminGetUsersSearchTypeEnum, keyword?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (level !== undefined) {
                localVarQueryParameter['level'] = level;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (searchType !== undefined) {
                localVarQueryParameter['searchType'] = searchType;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 관리자 회원 탈퇴 민원 처리
         * @param {AdminPatchHandlingWithdrawalComplainReqBodyDto} adminPatchHandlingWithdrawalComplainReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerAdminPatchHandlingWithdrawalComplain: async (adminPatchHandlingWithdrawalComplainReqBodyDto: AdminPatchHandlingWithdrawalComplainReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminPatchHandlingWithdrawalComplainReqBodyDto' is not null or undefined
            assertParamExists('adminUsersControllerAdminPatchHandlingWithdrawalComplain', 'adminPatchHandlingWithdrawalComplainReqBodyDto', adminPatchHandlingWithdrawalComplainReqBodyDto)
            const localVarPath = `/admin/users/withdrawal-complain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPatchHandlingWithdrawalComplainReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 관리자 회원 수정
         * @param {string} userUuid 유저 uuid
         * @param {AdminPatchUserByUserUuidReqBodyDto} adminPatchUserByUserUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerAdminPatchUserById: async (userUuid: string, adminPatchUserByUserUuidReqBodyDto: AdminPatchUserByUserUuidReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userUuid' is not null or undefined
            assertParamExists('adminUsersControllerAdminPatchUserById', 'userUuid', userUuid)
            // verify required parameter 'adminPatchUserByUserUuidReqBodyDto' is not null or undefined
            assertParamExists('adminUsersControllerAdminPatchUserById', 'adminPatchUserByUserUuidReqBodyDto', adminPatchUserByUserUuidReqBodyDto)
            const localVarPath = `/admin/users/{userUuid}`
                .replace(`{${"userUuid"}}`, encodeURIComponent(String(userUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPatchUserByUserUuidReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 회원 포인트 일괄 지급
         * @param {AdminPatchUserPointByUserUuidsReqBodyDto} adminPatchUserPointByUserUuidsReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerAdminPatchUsersPoint: async (adminPatchUserPointByUserUuidsReqBodyDto: AdminPatchUserPointByUserUuidsReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminPatchUserPointByUserUuidsReqBodyDto' is not null or undefined
            assertParamExists('adminUsersControllerAdminPatchUsersPoint', 'adminPatchUserPointByUserUuidsReqBodyDto', adminPatchUserPointByUserUuidsReqBodyDto)
            const localVarPath = `/admin/users/point`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPatchUserPointByUserUuidsReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 회원 가입 경로 조회
         * @param {number} [page] 페이지 번호
         * @param {number} [limit] 한 페이지에 보여줄 개수
         * @param {string} [keyword] 검색어
         * @param {Array<AdminUsersControllerGetRegisterPathRegisterPathTypeEnumsEnum>} [registerPathTypeEnums] 회원가입 경로 타입 목록
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerGetRegisterPath: async (page?: number, limit?: number, keyword?: string, registerPathTypeEnums?: Array<AdminUsersControllerGetRegisterPathRegisterPathTypeEnumsEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/users/register/funnels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (registerPathTypeEnums) {
                localVarQueryParameter['registerPathTypeEnums'] = registerPathTypeEnums;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 회원 가입 경로목록 및 경로별 사용자 수 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerGetRegisterPathList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/users/register/funnels/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminUsersApi - functional programming interface
 * @export
 */
export const AdminUsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminUsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 전체 관리자 회원명 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUsersControllerAdminGetAdminUsersName(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetUsersNameOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUsersControllerAdminGetAdminUsersName(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.adminUsersControllerAdminGetAdminUsersName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 관리자 본인 정보 가져오기
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUsersControllerAdminGetCurrentAdminUserInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetCurrentAdminUserInfoOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUsersControllerAdminGetCurrentAdminUserInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.adminUsersControllerAdminGetCurrentAdminUserInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 관리자 회원 상세 조회
         * @param {string} userUuid 유저 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUsersControllerAdminGetUserByUserUuid(userUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetUserByUserUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUsersControllerAdminGetUserByUserUuid(userUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.adminUsersControllerAdminGetUserByUserUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 관리자 회원 목록 조회
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {AdminUsersControllerAdminGetUsersCategoryEnum} [category] 유저 카테고리
         * @param {AdminUsersControllerAdminGetUsersLevelEnum} [level] 등급
         * @param {AdminUsersControllerAdminGetUsersSortEnum} [sort] 정렬 기준
         * @param {AdminUsersControllerAdminGetUsersSortOrderEnum} [sortOrder] 정렬 순서
         * @param {AdminUsersControllerAdminGetUsersSearchTypeEnum} [searchType] 검색 타입
         * @param {string} [keyword] 검색어
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUsersControllerAdminGetUsers(page?: number, limit?: number, category?: AdminUsersControllerAdminGetUsersCategoryEnum, level?: AdminUsersControllerAdminGetUsersLevelEnum, sort?: AdminUsersControllerAdminGetUsersSortEnum, sortOrder?: AdminUsersControllerAdminGetUsersSortOrderEnum, searchType?: AdminUsersControllerAdminGetUsersSearchTypeEnum, keyword?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetUsersOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUsersControllerAdminGetUsers(page, limit, category, level, sort, sortOrder, searchType, keyword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.adminUsersControllerAdminGetUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 관리자 회원 탈퇴 민원 처리
         * @param {AdminPatchHandlingWithdrawalComplainReqBodyDto} adminPatchHandlingWithdrawalComplainReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUsersControllerAdminPatchHandlingWithdrawalComplain(adminPatchHandlingWithdrawalComplainReqBodyDto: AdminPatchHandlingWithdrawalComplainReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPatchHandlingWithdrawalComplainOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUsersControllerAdminPatchHandlingWithdrawalComplain(adminPatchHandlingWithdrawalComplainReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.adminUsersControllerAdminPatchHandlingWithdrawalComplain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 관리자 회원 수정
         * @param {string} userUuid 유저 uuid
         * @param {AdminPatchUserByUserUuidReqBodyDto} adminPatchUserByUserUuidReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUsersControllerAdminPatchUserById(userUuid: string, adminPatchUserByUserUuidReqBodyDto: AdminPatchUserByUserUuidReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPatchUserByUserUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUsersControllerAdminPatchUserById(userUuid, adminPatchUserByUserUuidReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.adminUsersControllerAdminPatchUserById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 회원 포인트 일괄 지급
         * @param {AdminPatchUserPointByUserUuidsReqBodyDto} adminPatchUserPointByUserUuidsReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUsersControllerAdminPatchUsersPoint(adminPatchUserPointByUserUuidsReqBodyDto: AdminPatchUserPointByUserUuidsReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPatchUserByUserUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUsersControllerAdminPatchUsersPoint(adminPatchUserPointByUserUuidsReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.adminUsersControllerAdminPatchUsersPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 회원 가입 경로 조회
         * @param {number} [page] 페이지 번호
         * @param {number} [limit] 한 페이지에 보여줄 개수
         * @param {string} [keyword] 검색어
         * @param {Array<AdminUsersControllerGetRegisterPathRegisterPathTypeEnumsEnum>} [registerPathTypeEnums] 회원가입 경로 타입 목록
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUsersControllerGetRegisterPath(page?: number, limit?: number, keyword?: string, registerPathTypeEnums?: Array<AdminUsersControllerGetRegisterPathRegisterPathTypeEnumsEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRegisterPathOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUsersControllerGetRegisterPath(page, limit, keyword, registerPathTypeEnums, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.adminUsersControllerGetRegisterPath']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 회원 가입 경로목록 및 경로별 사용자 수 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUsersControllerGetRegisterPathList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRegisterPathListOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUsersControllerGetRegisterPathList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.adminUsersControllerGetRegisterPathList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminUsersApi - factory interface
 * @export
 */
export const AdminUsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminUsersApiFp(configuration)
    return {
        /**
         * 
         * @summary 전체 관리자 회원명 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerAdminGetAdminUsersName(options?: RawAxiosRequestConfig): AxiosPromise<AdminGetUsersNameOkDto> {
            return localVarFp.adminUsersControllerAdminGetAdminUsersName(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 관리자 본인 정보 가져오기
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerAdminGetCurrentAdminUserInfo(options?: RawAxiosRequestConfig): AxiosPromise<AdminGetCurrentAdminUserInfoOkDto> {
            return localVarFp.adminUsersControllerAdminGetCurrentAdminUserInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 관리자 회원 상세 조회
         * @param {AdminUsersApiAdminUsersControllerAdminGetUserByUserUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerAdminGetUserByUserUuid(requestParameters: AdminUsersApiAdminUsersControllerAdminGetUserByUserUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminGetUserByUserUuidOkDto> {
            return localVarFp.adminUsersControllerAdminGetUserByUserUuid(requestParameters.userUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 관리자 회원 목록 조회
         * @param {AdminUsersApiAdminUsersControllerAdminGetUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerAdminGetUsers(requestParameters: AdminUsersApiAdminUsersControllerAdminGetUsersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminGetUsersOkDto> {
            return localVarFp.adminUsersControllerAdminGetUsers(requestParameters.page, requestParameters.limit, requestParameters.category, requestParameters.level, requestParameters.sort, requestParameters.sortOrder, requestParameters.searchType, requestParameters.keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 관리자 회원 탈퇴 민원 처리
         * @param {AdminUsersApiAdminUsersControllerAdminPatchHandlingWithdrawalComplainRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerAdminPatchHandlingWithdrawalComplain(requestParameters: AdminUsersApiAdminUsersControllerAdminPatchHandlingWithdrawalComplainRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPatchHandlingWithdrawalComplainOkDto> {
            return localVarFp.adminUsersControllerAdminPatchHandlingWithdrawalComplain(requestParameters.adminPatchHandlingWithdrawalComplainReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 관리자 회원 수정
         * @param {AdminUsersApiAdminUsersControllerAdminPatchUserByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerAdminPatchUserById(requestParameters: AdminUsersApiAdminUsersControllerAdminPatchUserByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPatchUserByUserUuidOkDto> {
            return localVarFp.adminUsersControllerAdminPatchUserById(requestParameters.userUuid, requestParameters.adminPatchUserByUserUuidReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 회원 포인트 일괄 지급
         * @param {AdminUsersApiAdminUsersControllerAdminPatchUsersPointRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerAdminPatchUsersPoint(requestParameters: AdminUsersApiAdminUsersControllerAdminPatchUsersPointRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPatchUserByUserUuidOkDto> {
            return localVarFp.adminUsersControllerAdminPatchUsersPoint(requestParameters.adminPatchUserPointByUserUuidsReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 회원 가입 경로 조회
         * @param {AdminUsersApiAdminUsersControllerGetRegisterPathRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerGetRegisterPath(requestParameters: AdminUsersApiAdminUsersControllerGetRegisterPathRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetRegisterPathOkDto> {
            return localVarFp.adminUsersControllerGetRegisterPath(requestParameters.page, requestParameters.limit, requestParameters.keyword, requestParameters.registerPathTypeEnums, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 회원 가입 경로목록 및 경로별 사용자 수 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerGetRegisterPathList(options?: RawAxiosRequestConfig): AxiosPromise<GetRegisterPathListOkDto> {
            return localVarFp.adminUsersControllerGetRegisterPathList(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminUsersControllerAdminGetUserByUserUuid operation in AdminUsersApi.
 * @export
 * @interface AdminUsersApiAdminUsersControllerAdminGetUserByUserUuidRequest
 */
export interface AdminUsersApiAdminUsersControllerAdminGetUserByUserUuidRequest {
    /**
     * 유저 uuid
     * @type {string}
     * @memberof AdminUsersApiAdminUsersControllerAdminGetUserByUserUuid
     */
    readonly userUuid: string
}

/**
 * Request parameters for adminUsersControllerAdminGetUsers operation in AdminUsersApi.
 * @export
 * @interface AdminUsersApiAdminUsersControllerAdminGetUsersRequest
 */
export interface AdminUsersApiAdminUsersControllerAdminGetUsersRequest {
    /**
     * 현재 페이지
     * @type {number}
     * @memberof AdminUsersApiAdminUsersControllerAdminGetUsers
     */
    readonly page?: number

    /**
     * 한 페이지에 보여줄 데이터 수
     * @type {number}
     * @memberof AdminUsersApiAdminUsersControllerAdminGetUsers
     */
    readonly limit?: number

    /**
     * 유저 카테고리
     * @type {'all' | 'like' | 'ban' | 'memo'}
     * @memberof AdminUsersApiAdminUsersControllerAdminGetUsers
     */
    readonly category?: AdminUsersControllerAdminGetUsersCategoryEnum

    /**
     * 등급
     * @type {'all'}
     * @memberof AdminUsersApiAdminUsersControllerAdminGetUsers
     */
    readonly level?: AdminUsersControllerAdminGetUsersLevelEnum

    /**
     * 정렬 기준
     * @type {'accounts' | 'earnedPoint' | 'totalExchangedPoint' | 'totalPoint' | 'createdAt' | 'lastAccessedAt'}
     * @memberof AdminUsersApiAdminUsersControllerAdminGetUsers
     */
    readonly sort?: AdminUsersControllerAdminGetUsersSortEnum

    /**
     * 정렬 순서
     * @type {'desc' | 'asc'}
     * @memberof AdminUsersApiAdminUsersControllerAdminGetUsers
     */
    readonly sortOrder?: AdminUsersControllerAdminGetUsersSortOrderEnum

    /**
     * 검색 타입
     * @type {'name' | 'id'}
     * @memberof AdminUsersApiAdminUsersControllerAdminGetUsers
     */
    readonly searchType?: AdminUsersControllerAdminGetUsersSearchTypeEnum

    /**
     * 검색어
     * @type {string}
     * @memberof AdminUsersApiAdminUsersControllerAdminGetUsers
     */
    readonly keyword?: string
}

/**
 * Request parameters for adminUsersControllerAdminPatchHandlingWithdrawalComplain operation in AdminUsersApi.
 * @export
 * @interface AdminUsersApiAdminUsersControllerAdminPatchHandlingWithdrawalComplainRequest
 */
export interface AdminUsersApiAdminUsersControllerAdminPatchHandlingWithdrawalComplainRequest {
    /**
     * 
     * @type {AdminPatchHandlingWithdrawalComplainReqBodyDto}
     * @memberof AdminUsersApiAdminUsersControllerAdminPatchHandlingWithdrawalComplain
     */
    readonly adminPatchHandlingWithdrawalComplainReqBodyDto: AdminPatchHandlingWithdrawalComplainReqBodyDto
}

/**
 * Request parameters for adminUsersControllerAdminPatchUserById operation in AdminUsersApi.
 * @export
 * @interface AdminUsersApiAdminUsersControllerAdminPatchUserByIdRequest
 */
export interface AdminUsersApiAdminUsersControllerAdminPatchUserByIdRequest {
    /**
     * 유저 uuid
     * @type {string}
     * @memberof AdminUsersApiAdminUsersControllerAdminPatchUserById
     */
    readonly userUuid: string

    /**
     * 
     * @type {AdminPatchUserByUserUuidReqBodyDto}
     * @memberof AdminUsersApiAdminUsersControllerAdminPatchUserById
     */
    readonly adminPatchUserByUserUuidReqBodyDto: AdminPatchUserByUserUuidReqBodyDto
}

/**
 * Request parameters for adminUsersControllerAdminPatchUsersPoint operation in AdminUsersApi.
 * @export
 * @interface AdminUsersApiAdminUsersControllerAdminPatchUsersPointRequest
 */
export interface AdminUsersApiAdminUsersControllerAdminPatchUsersPointRequest {
    /**
     * 
     * @type {AdminPatchUserPointByUserUuidsReqBodyDto}
     * @memberof AdminUsersApiAdminUsersControllerAdminPatchUsersPoint
     */
    readonly adminPatchUserPointByUserUuidsReqBodyDto: AdminPatchUserPointByUserUuidsReqBodyDto
}

/**
 * Request parameters for adminUsersControllerGetRegisterPath operation in AdminUsersApi.
 * @export
 * @interface AdminUsersApiAdminUsersControllerGetRegisterPathRequest
 */
export interface AdminUsersApiAdminUsersControllerGetRegisterPathRequest {
    /**
     * 페이지 번호
     * @type {number}
     * @memberof AdminUsersApiAdminUsersControllerGetRegisterPath
     */
    readonly page?: number

    /**
     * 한 페이지에 보여줄 개수
     * @type {number}
     * @memberof AdminUsersApiAdminUsersControllerGetRegisterPath
     */
    readonly limit?: number

    /**
     * 검색어
     * @type {string}
     * @memberof AdminUsersApiAdminUsersControllerGetRegisterPath
     */
    readonly keyword?: string

    /**
     * 회원가입 경로 타입 목록
     * @type {Array<'friendlyRecommend' | 'search' | 'naver' | 'youtube' | 'instagram' | 'facebook' | 'other'>}
     * @memberof AdminUsersApiAdminUsersControllerGetRegisterPath
     */
    readonly registerPathTypeEnums?: Array<AdminUsersControllerGetRegisterPathRegisterPathTypeEnumsEnum>
}

/**
 * AdminUsersApi - object-oriented interface
 * @export
 * @class AdminUsersApi
 * @extends {BaseAPI}
 */
export class AdminUsersApi extends BaseAPI {
    /**
     * 
     * @summary 전체 관리자 회원명 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public adminUsersControllerAdminGetAdminUsersName(options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).adminUsersControllerAdminGetAdminUsersName(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 관리자 본인 정보 가져오기
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public adminUsersControllerAdminGetCurrentAdminUserInfo(options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).adminUsersControllerAdminGetCurrentAdminUserInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 관리자 회원 상세 조회
     * @param {AdminUsersApiAdminUsersControllerAdminGetUserByUserUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public adminUsersControllerAdminGetUserByUserUuid(requestParameters: AdminUsersApiAdminUsersControllerAdminGetUserByUserUuidRequest, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).adminUsersControllerAdminGetUserByUserUuid(requestParameters.userUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 관리자 회원 목록 조회
     * @param {AdminUsersApiAdminUsersControllerAdminGetUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public adminUsersControllerAdminGetUsers(requestParameters: AdminUsersApiAdminUsersControllerAdminGetUsersRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).adminUsersControllerAdminGetUsers(requestParameters.page, requestParameters.limit, requestParameters.category, requestParameters.level, requestParameters.sort, requestParameters.sortOrder, requestParameters.searchType, requestParameters.keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 관리자 회원 탈퇴 민원 처리
     * @param {AdminUsersApiAdminUsersControllerAdminPatchHandlingWithdrawalComplainRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public adminUsersControllerAdminPatchHandlingWithdrawalComplain(requestParameters: AdminUsersApiAdminUsersControllerAdminPatchHandlingWithdrawalComplainRequest, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).adminUsersControllerAdminPatchHandlingWithdrawalComplain(requestParameters.adminPatchHandlingWithdrawalComplainReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 관리자 회원 수정
     * @param {AdminUsersApiAdminUsersControllerAdminPatchUserByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public adminUsersControllerAdminPatchUserById(requestParameters: AdminUsersApiAdminUsersControllerAdminPatchUserByIdRequest, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).adminUsersControllerAdminPatchUserById(requestParameters.userUuid, requestParameters.adminPatchUserByUserUuidReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 회원 포인트 일괄 지급
     * @param {AdminUsersApiAdminUsersControllerAdminPatchUsersPointRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public adminUsersControllerAdminPatchUsersPoint(requestParameters: AdminUsersApiAdminUsersControllerAdminPatchUsersPointRequest, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).adminUsersControllerAdminPatchUsersPoint(requestParameters.adminPatchUserPointByUserUuidsReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 회원 가입 경로 조회
     * @param {AdminUsersApiAdminUsersControllerGetRegisterPathRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public adminUsersControllerGetRegisterPath(requestParameters: AdminUsersApiAdminUsersControllerGetRegisterPathRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).adminUsersControllerGetRegisterPath(requestParameters.page, requestParameters.limit, requestParameters.keyword, requestParameters.registerPathTypeEnums, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 회원 가입 경로목록 및 경로별 사용자 수 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public adminUsersControllerGetRegisterPathList(options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).adminUsersControllerGetRegisterPathList(options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AdminUsersControllerAdminGetUsersCategoryEnum = {
    All: 'all',
    Like: 'like',
    Ban: 'ban',
    Memo: 'memo'
} as const;
export type AdminUsersControllerAdminGetUsersCategoryEnum = typeof AdminUsersControllerAdminGetUsersCategoryEnum[keyof typeof AdminUsersControllerAdminGetUsersCategoryEnum];
/**
 * @export
 */
export const AdminUsersControllerAdminGetUsersLevelEnum = {
    All: 'all'
} as const;
export type AdminUsersControllerAdminGetUsersLevelEnum = typeof AdminUsersControllerAdminGetUsersLevelEnum[keyof typeof AdminUsersControllerAdminGetUsersLevelEnum];
/**
 * @export
 */
export const AdminUsersControllerAdminGetUsersSortEnum = {
    Accounts: 'accounts',
    EarnedPoint: 'earnedPoint',
    TotalExchangedPoint: 'totalExchangedPoint',
    TotalPoint: 'totalPoint',
    CreatedAt: 'createdAt',
    LastAccessedAt: 'lastAccessedAt'
} as const;
export type AdminUsersControllerAdminGetUsersSortEnum = typeof AdminUsersControllerAdminGetUsersSortEnum[keyof typeof AdminUsersControllerAdminGetUsersSortEnum];
/**
 * @export
 */
export const AdminUsersControllerAdminGetUsersSortOrderEnum = {
    Desc: 'desc',
    Asc: 'asc'
} as const;
export type AdminUsersControllerAdminGetUsersSortOrderEnum = typeof AdminUsersControllerAdminGetUsersSortOrderEnum[keyof typeof AdminUsersControllerAdminGetUsersSortOrderEnum];
/**
 * @export
 */
export const AdminUsersControllerAdminGetUsersSearchTypeEnum = {
    Name: 'name',
    Id: 'id'
} as const;
export type AdminUsersControllerAdminGetUsersSearchTypeEnum = typeof AdminUsersControllerAdminGetUsersSearchTypeEnum[keyof typeof AdminUsersControllerAdminGetUsersSearchTypeEnum];
/**
 * @export
 */
export const AdminUsersControllerGetRegisterPathRegisterPathTypeEnumsEnum = {
    FriendlyRecommend: 'friendlyRecommend',
    Search: 'search',
    Naver: 'naver',
    Youtube: 'youtube',
    Instagram: 'instagram',
    Facebook: 'facebook',
    Other: 'other'
} as const;
export type AdminUsersControllerGetRegisterPathRegisterPathTypeEnumsEnum = typeof AdminUsersControllerGetRegisterPathRegisterPathTypeEnumsEnum[keyof typeof AdminUsersControllerGetRegisterPathRegisterPathTypeEnumsEnum];
